import { FC, Fragment } from 'react';
import type { MenuConfig } from 'alurkerja-ui';
import Menu from './Menu';
import MenuWithSub from './MenuWithSub';

interface ListMenuProps {
  menuConfig: MenuConfig[];
  currentPathName?: string;
  toggled: boolean;
  menuWrapper?: ({ children, menu }: { children: JSX.Element; menu: MenuConfig }) => JSX.Element;
  isChildren?: boolean;
}

const ListMenu: FC<ListMenuProps> = ({ menuConfig, currentPathName, toggled, menuWrapper, isChildren }) => {
  return (
    <>
      {menuConfig.map((menu, idx) => (
        <Fragment key={idx}>
          {!toggled && menu.groupBy && (
            <div className="mt-5 w-full h-10 text-[#5E5E5E] font-semibold flex items-center px-6">{menu.groupBy}</div>
          )}
          {!menu.child ? (
            <Menu
              menu={menu}
              toggled={toggled}
              menuWrapper={menuWrapper}
              isChildren={isChildren}
            />
          ) : (
            <MenuWithSub
              menu={menu}
              toggled={toggled}
              currentPathName={currentPathName}
              menuWrapper={menuWrapper}
              isChildren={isChildren}
            />
          )}
        </Fragment>
      ))}
    </>
  );
};

export default ListMenu;
